import { DistributionChannel } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import {
  IconAirbnbRectangle,
  IconAvantstayRectangle,
  IconVRBORectangle,
} from '@avantstay/backoffice-vectors'

export const getOtaChannelIcon = (distributionChannel: string) => {
  switch (distributionChannel) {
    case DistributionChannel.airbnb:
      return <IconAirbnbRectangle />
    case DistributionChannel.vrbo:
      return <IconVRBORectangle />
    case DistributionChannel.avantstay:
      return <IconAvantstayRectangle />
    default:
      return null
  }
}
